import React from "react";

const Navbar = () => {
  return (
    <div>
      <div className="header">Your Personalized Todo List</div>
    </div>
  );
};

export default Navbar;
